
import {Component, Vue} from 'vue-property-decorator';
import {dispatchDeleteFormBatch, dispatchGetFormBatchesAdmin} from '@/store/main/actions';
import {readFormBatches, readFormBatchesStats} from '@/store/main/getters';
import ShowSingleList from '@/components/dialogs/ShowSingleList.vue';
import DynamicTableSimpleAsync from '@/components/datatables/DynamicTableSimpleAsync.vue';

@Component({
  components: {ShowSingleList, DynamicTableSimpleAsync},
})
export default class FormBathList extends Vue {

  public headers = [
    // router_name: 'main-admin-forms_search_engines-edit'
    {
      text: this.$t('action'), value: 'action', align: 'center', filterable: false, sortable: false,
      router_name: 'main-admin-form-batch-edit', width: '100px', delete_function: this.deleteFunction,
    },
    {text: this.$t('registered-data'), value: 'registered_values', sortable: false, align: 'left', width: 200},
    {text: this.$t('detail'), value: 'show_registered_batch', sortable: false, align: 'center'},
    {text: this.$t('form'), value: 'form_name', sortable: false, align: 'left'},
    // {text: this.$t('formID'), value: 'form_id', sortable: true, align: 'center'},
    // {text: this.$t('version'), value: 'version', sortable: true, align: 'center'},
    {text: this.$t('requester'), value: 'requester', sortable: false, align: 'left', object_key: 'fullname'},
    {text: this.$t('released_by_user'), value: 'released_by_user', sortable: false, align: 'left', object_key: 'fullname'},
    {text: this.$t('created_at'), value: 'created_at', sortable: true, align: 'left', type: 'date'},
    {text: this.$t('released_batch'), value: 'released_batch', sortable: false, align: 'center'},
    {text: this.$t('delivery_completed'), value: 'delivery_completed', sortable: false, align: 'center'},
    {text: this.$t('released_by_SVO'), value: 'released_by_SVO', sortable: false, align: 'center'},
    {text: this.$t('batch_launched_SIM'), value: 'batch_launched_SIM', sortable: false, align: 'center'},
    {text: this.$t('origin_request'), value: 'origin_request', sortable: true, align: 'left'},
  ];

  public headersRemained = [
    {text: this.$t('field_reference'), value: 'field_reference', sortable: true, align: 'left'},
    {text: this.$t('range_values'), value: 'range_values', sortable: true, align: 'left'},
    {text: this.$t('quantity_requested'), value: 'quantity_requested', sortable: false, align: 'right'},
    {text: this.$t('observations'), value: 'observation', sortable: false, align: 'left'},
    {text: this.$t('quantity_released'), value: 'quantity_released', sortable: false, align: 'right'},
    {text: this.$t('released_at'), value: 'released_at', sortable: false, align: 'left', type: 'date'},
    {text: this.$t('updated_at'), value: 'updated_at', sortable: false, align: 'left', type: 'date'},
    {text: this.$t('observations_admin'), value: 'observation_admin', sortable: false, align: 'left'},
    {text: this.$t('observation_admin_internal'), value: 'observation_admin_internal', sortable: false, align: 'left'},
  ];

  private numberOfPages: number = 0;
  private totalItems: number = 0;

  public async mounted() {
    // await dispatchGetFormBatches(this.$store, {with_stats: false, skip: 0, limit: -1});
  }

  public async loadDataAPI(payload: any) {
    payload.with_stats = false;
    const response = await dispatchGetFormBatchesAdmin(this.$store, payload);

    if (response) {
      this.totalItems = response.data.total_items;
      this.numberOfPages = response.data.total_items_page;
    }
  }

  private async deleteFunction(id) {
    await dispatchDeleteFormBatch(this.$store, id);
    await dispatchGetFormBatchesAdmin(this.$store, {with_stats: false, skip: 0, limit: -1});
  }


  private get formBatches() {
    return readFormBatches(this.$store);
  }

  private get formBatchesStats() {
    return readFormBatchesStats(this.$store);
  }
}
